<template>
	<div id="search">
		<div class="search_top">
			<div class="search_width clearfix">
				<div class="left">
					<router-link to="/" class="search_logo"></router-link>
					<div class="left left_text">参加培训企业名录公示</div>
				</div>
				<div class="right">
					<div class="seach_sea">
						<input type="text" v-model.trim="qyMc" class="search_ipt" placeholder="请输入想查找的企业名称" />
						<div class="seach_btn" @click="getDataTab"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="tab_btn">
			<div class="search_width">
				<el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
					<el-radio-button label="0">培训公示</el-radio-button>
					<el-radio-button label="1">信用报告公示</el-radio-button>
				</el-radio-group>
			</div>
		</div>
		
		
		<div class="search_tabel" v-show="tabPosition == '0'">
			<div class="search_width">
				<div class="tab_box">
					<el-table
					    :data="tableData"
						border
						stripe
					    style="width: 100%">
					    <el-table-column
					      type="index"
						  width="120"
						  label="序号"
						>
					    </el-table-column>
					    <el-table-column
					      prop="qyMc"
						  width="400"
					      label="企业名称">
					    </el-table-column>
						<el-table-column
						  prop="cxsj"
						  label="参训时间">
						</el-table-column>
						<el-table-column
						  prop="pxcj"
						  label="培训成绩">
						</el-table-column>
						<el-table-column
						  prop="qySa01"
						  label="证书编号">
						</el-table-column>
						<el-table-column
						  prop="fwjg"
						  label="服务机构">
						</el-table-column>
					</el-table>
				</div>
				<div class="tabel_pagetion">
					<el-pagination
					  v-if="total > 10"
					  background
					  :page-size="pageLimit"
					  layout="prev, pager, next"
					  @current-change="getCurrent"
					  :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
		
		<div class="search_tabel" v-show="tabPosition == '1'">
			<div class="search_width">
				<div class="tab_box">
					<el-table
					    :data="tableData1"
						border
						stripe
					    style="width: 100%">
					    <el-table-column
					      type="index"
						  width="120"
						  label="序号"
						>
					    </el-table-column>
					    <el-table-column
					      prop="qyMc"
						  width="400"
					      label="企业名称">
					    </el-table-column>
						<el-table-column
						  prop="bgrq"
						  label="报告时间">
						</el-table-column>
						<el-table-column
						  prop="qySa01"
						  label="报告编号">
						</el-table-column>
						<el-table-column
						  prop="fwjg"
						  label="服务机构">
						</el-table-column>
					</el-table>
				</div>
				<div class="tabel_pagetion">
					<el-pagination
					v-if="total1>10"
					  background
					  :page-size="pageLimit1"
					  layout="prev, pager, next"
					  @current-change="getCurrent1"
					  :total="total1">
					</el-pagination>
				</div>
			</div>
		</div>
		
		
		<indexFooter></indexFooter>
	</div>
</template>

<script>
	import indexFooter from "@/components/index/index_footer";
	import { cookie } from "@/common/js/cookies.js";
	export default {
		data(){
			return {
				tableData: [],
				qyMc: '',		//企业名称
				pageLimit: 20,	//每页数量
				currPage: 1,	//当前页码
				total: 20,		//总数量
				
				tabPosition: '0',
				tableData1: [],
				pageLimit1: 20,	//每页数量
				currPage1: 1,	//当前页码
				total1: 20,		//总数量
			}
		},
		methods:{
			//搜索查看执行哪个搜索
			getDataTab(){
				if(this.tabPosition == '0'){
					this.getData()
				}else{
					this.getData1()
				}
			},
			getCurrent(da){
				this.currPage = da;
				this.getData();
			},
			//获取数据
			getData: function () {
			  let _self = this;
			  let ajax = _self.$http.create();
			  const loading = this.$loading({
			    lock: true,
			    text: "Loading",
			    spinner: "el-icon-loading",
			    background: "rgba(0, 0, 0, 0.7)",
				target: document.querySelector('#app')
			  });
			  let data = {
				  qyMc: _self.qyMc,
				  pageLimit: _self.pageLimit,
				  currPage: _self.currPage,
			  };
			  
			  ajax({
			    method: 'post',
			    url: SOWINURL + 'report/makeList',
			    data: data,
				headers:{
					'token': cookie.get("xyxf_token_qt")
				}
			  }).then(function (json) {
			    if (json.data.result == 1) {
				  _self.tableData = json.data.data.list;
				  _self.total = json.data.data.allNum;
			    } 
				loading.close();
			  }).catch(function (error) {
				  loading.close();
			    console.log(error);
			  });
			},
			
			//第二段
			getCurrent1(da){
				this.currPage1 = da;
				this.getData1();
			},
			//获取数据
			getData1: function () {
			  let _self = this;
			  let ajax = _self.$http.create();
			  const loading = this.$loading({
			    lock: true,
			    text: "Loading",
			    spinner: "el-icon-loading",
			    background: "rgba(0, 0, 0, 0.7)",
				target: document.querySelector('#app')
			  });
			  let data = {
				  qyMc: _self.qyMc,
				  pageLimit: _self.pageLimit1,
				  currPage: _self.currPage1,
			  };
			  
			  ajax({
			    method: 'post',
			    url: SOWINURL + 'report/makeReportList',
			    data: data,
				headers:{
					'token': cookie.get("xyxf_token_qt")
				}
			  }).then(function (json) {
			    if (json.data.result == 1) {
				  _self.tableData1 = json.data.data.list;
				  _self.total1 = json.data.data.allNum;
			    } 
				loading.close();
			  }).catch(function (error) {
				  loading.close();
			    console.log(error);
			  });
			},
		},
		created(){
			this.getData();
			this.getData1();
		},
		mounted(){
			// document.getElementsByTagName('body')[0].style.backgroundColor = '#FFFFFF';
		},
		components: {
		  indexFooter
		}
	}
</script>

<style scoped>
.tab_btn{
	background-color: #FFFFFF;
	padding-top: 50px;
}
.tab_btn .el-radio-group{
	margin-bottom: 0 !important;
}
.tabel_pagetion{
	width: 100%;
	padding: 20px 0;
}
.tabel_pagetion .el-pagination{
	float: right;
}
.tabel_pagetion
.el-table{
	color: #000;
	background-color: #f7f7f7;
	font-size: 16px;
}

	.search_top{
		width: 100%;
		padding: 30px 0;
		background-color: #6883f4;
	}
	.search_width{
		width: 1400px;
		margin: 0 auto;
	}
	.left{
		float: left;
	}
	.right{
		float: right;
	}
	.search_logo{
		display: block;
		width: 69px;
		height: 46px;
		background: url(/static/images/search_logo.png) no-repeat center center;
		background-size: 100%;
		float: left;
	}
	.left_text{
		line-height: 42px;
		font-size: 30px;
		color: #fff;
		padding-left: 20px;
		
	}
	.seach_sea{
		height: 46px;
		width: 548px;
		position: relative;
	}
	.search_ipt{
		outline: none;
		border: 0;
		height: 46px;
		width: 448px;
		padding: 0 70px 0 30px;
		border-radius: 23px;
		font-size: 16px;
		color: #666;
	}
	input.search_ipt::-webkit-input-placeholder{ 
		color: #999; 
		font-size: 14px;
	} 
	input.search_ipt:-moz-placeholder{ 
		color: #999; 
		font-size: 14px;
	} 
	input.search_ipt::-moz-placeholder{ 
		color: #999; 
		font-size: 14px;
	} 
	input.search_ipt:-ms-input-placeholder{ 
		color: #999; 
		font-size: 14px;
	}
	.seach_btn{
		width: 29px;
		height: 29px;
		padding: 8px 25px;
		background: url(/static/images/search_ico.png) no-repeat center center;
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
	}
	.tab_box{
		border-bottom: 0;
		background-color: #f7f7f7;
	}
	.search_tabel{
		padding: 50px 0;
		background-color: #FFFFFF;
		min-height: 530px;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/index_search.vue